import { render, staticRenderFns } from "./thirdRiskHazardPicture.vue?vue&type=template&id=e104893c"
import script from "./thirdRiskHazardPicture.vue?vue&type=script&lang=js"
export * from "./thirdRiskHazardPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e104893c')) {
      api.createRecord('e104893c', component.options)
    } else {
      api.reload('e104893c', component.options)
    }
    module.hot.accept("./thirdRiskHazardPicture.vue?vue&type=template&id=e104893c", function () {
      api.rerender('e104893c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/action/thirdRiskHazardPicture.vue"
export default component.exports